import { useState } from 'react';
import { FormNames } from '@youscience/commonapp-service-common';
import { CoreBox, CoreTypography } from '@youscience/core';
import { Link } from '@mui/material';

import SectionAccordion from '@components/SectionAccordion';
import ActionButton from '@components/ActionButton';

import { formatDateWithFallback } from '@utils/formatter';

import { useApplicantFormsMetadata } from '@pages/StudentDetailsPage/hooks/useApplicantFormsMetadata';
import { FormCompletionStatus } from '../enums';

export const Submissions = (props: {
  formName: FormNames;
  onSubmit: () => void;
  isPending?: boolean;
  teacherId?: number;
}) => {
  const { formName, onSubmit, isPending } = props;
  const { formsMetadata } = useApplicantFormsMetadata();
  const formMetadata = formsMetadata[formName];
  const [isExpanded, setIsExpanded] = useState(true);

  if (!formMetadata) {
    return null;
  }

  return (
    <SectionAccordion
      title={formMetadata.submittedDate ? `Submitted on ${formatDateWithFallback(formMetadata.submittedDate)}` : ''}
      isExpanded={isExpanded}
      onChange={() => setIsExpanded(!isExpanded)}
    >
      <CoreBox sx={{ display: 'flex', flexDirection: 'column' }}>
        {isPending && (
          <CoreTypography>
            Your evaluation for the student will be submitted for the following list of colleges after counselor
            approval.
          </CoreTypography>
        )}
        <CoreBox sx={{ display: 'flex', gap: '.5rem', flexDirection: 'column', padding: '1rem 0rem' }}>
          {!isPending && (
            <CoreTypography variant="subtitle2" component="h4">
              Downloaded date
            </CoreTypography>
          )}

          {formMetadata.members.map((member) => {
            if (isPending) {
              if (formMetadata.completionStatus === FormCompletionStatus.PENDING) {
                return (
                  <CoreTypography key={member.memberId} variant="body2">
                    <Link>{member.memberName}</Link>
                  </CoreTypography>
                );
              }
            } else {
              if (member.submittedDate || member.downloadedDate) {
                return (
                  <CoreTypography key={member.memberId} variant="body2">
                    <Link>{member.memberName}</Link>:{' '}
                    {member.downloadedDate ? formatDateWithFallback(member.downloadedDate) : 'Not yet downloaded'}
                  </CoreTypography>
                );
              }
            }
          })}
        </CoreBox>

        {formMetadata.completionStatus !== FormCompletionStatus.PENDING &&
          formMetadata.members.some((member) => !member.submittedDate && !member.downloadedDate) && (
            <CoreBox sx={{ padding: '1.5rem 0rem' }}>
              <ActionButton onClick={onSubmit}>Submit to another college</ActionButton>
            </CoreBox>
          )}
      </CoreBox>
    </SectionAccordion>
  );
};
